import React, { FunctionComponent, useCallback } from 'react';
import { Box } from 'rebass/styled-components';
import { components } from 'react-select';
import { Select } from '..';
import EditorDropdownItem from './editor-dropdown-item';
import {
  parseTitle, parseName, ConfigEditorType,
} from './util';
import { SelectType } from '../../enums';

export interface IEditorDropdownProps {
  value: any;
  onChange: (it: any) => void;
  items: Array<any>;
  actionType?: ConfigEditorType;
  noFreeText?: boolean;
  placeholder?: string;
  isErrored?: boolean;
  hasTransfer?: boolean;
}

const SingleValue = ({ data, children, ...props }: any) => {
  const { value, actionType, placeholder } = props.selectProps;

  return value?.value.length !== 0 ? (
    <components.SingleValue {...props}>
      <Box data-testid="editor-dropdown-single-value">
        {parseName(
          value?.value, actionType, placeholder, true, true,
        )}
      </Box>
    </components.SingleValue>
  ) : (
    <components.Placeholder {...props}>
      {placeholder}
    </components.Placeholder>
  );
};

const Option = ({ data, ...rest }: any) => {
  const { actionType, hasTransfer } = rest.selectProps;
  const { value } = data;
  return (
    <components.Option {...rest}>
      <EditorDropdownItem item={value} actionType={actionType} hasTransfer={hasTransfer} />
    </components.Option>
  );
};

const EditorDropdown: FunctionComponent<IEditorDropdownProps> = ({
  items, value, actionType, placeholder, hasTransfer, onChange, noFreeText, isErrored,
}: IEditorDropdownProps) => {
  const handleBlur = useCallback((ev: any) => {
    if (ev.currentTarget.value) {
      onChange(ev.currentTarget.value);
    }
  }, [onChange]);

  if (!noFreeText) {
    const options = items.map((it) => ({
      value: it,
      label: parseName(it, actionType, placeholder, true, true),
    }));

    const val = {
      value,
      label: value,
    };

    return (
      <Select
        aria-label="editor-select"
        tabSelectsValue={false}
        options={options}
        value={val}
        styles={() => ({
          input: (provided: any) => ({
            ...provided,
            fontSize: '13px',
          }),
        })}
        components={{
          SingleValue,
          Option,
        }}
        onChange={(ev: any) => {
          onChange(ev?.value ? ev.value : '');
        }}
        type={SelectType.NORMAL}
        noOptionsMessage={() => null}
        isSearchable
        onBlur={handleBlur}
        isErrored={isErrored}
        isClearable
        // below are props to be used in custom components
        actionType={actionType}
        placeholder={placeholder}
        hasTransfer={hasTransfer}
      />
    );
  }

  const options = items.map((it) => ({
    value: it,
    label: parseName(it, actionType, placeholder, true, true),
  }));

  const val = {
    value,
    label: parseTitle(value, actionType),
  };

  return (
    <Select
      aria-label="editor-select"
      options={options}
      value={val}
      styles={() => ({
        input: (provided: any) => ({
          ...provided,
          fontSize: '13px',
        }),
      })}
      components={{
        SingleValue,
        Option,
      }}
      onChange={(ev: any) => {
        onChange(ev.value);
      }}
      type={SelectType.NORMAL}
      isOptionDisabled={() => !!hasTransfer}
      noOptionsMessage={() => null}
      isSearchable={false}
      isErrored={isErrored}
      // below are props to be used in custom components
      actionType={actionType}
      placeholder={placeholder}
      hasTransfer={hasTransfer}
    />
  );
};

export default EditorDropdown;
